import Namespace from './type/Namespace';
import { Message } from './type/Message';

type T = (url: string) => Message;

const f: T = (url) => {
    return {
        namespace: Namespace.SHARE_LINKS_CLIENT,
        action: 'url-open',
        payload: {
            url,
        },
    };
};

export default f;
